/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

import type { MentionActe } from '@/types';

/**
 * Identifiant de la mention ANTS d'une mention lue sur la fiche, pour préremplir le dropdown
 * « Code ANTS » de la modale de modification.
 *
 * La route `/mentions` le renvoie directement (`identifiantCodeAnts`) : `codeMentionAnts`,
 * numérique lui aussi mais confirmé distinct sur des données réelles, ne permet pas de le
 * retrouver par recoupement (ce n'est ni le même identifiant, ni le `codeRefAnts` textuel
 * d'une catégorie ANTS).
 */
const resolveIdentifiantCodeAnts = (
  mention?: Partial<MentionActe> | null,
): number | undefined =>
  _.isNil(mention?.identifiantCodeAnts)
    ? undefined
    : Number(mention.identifiantCodeAnts);

export default resolveIdentifiantCodeAnts;
